import React  from "react";
// react plugin for creating charts
import ClientListTable from "components/ClientList/ClientListTable";

export default function Dashboard() {
  
  return (
    <div>
      <ClientListTable />
   
     </div>
  );
}
